import React, { useEffect, useState } from "react";
import { getOrdersList, cancelOrder } from "../../../services/apiService";
import { createPortal } from "react-dom";
import { showSnackbar } from "../../../comopnents/snackbar";

const AdminOrdersList = () => {
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [reason, setReason] = useState("");

  // Fetch orders
  const fetchOrders = async () => {
    try {
      const res = await getOrdersList();
      setOrders([...(res.data?.data || [])].reverse());
    } catch (error) {
      console.error("Error fetching orders", error);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  // Prevent body scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = showModal ? "hidden" : "auto";
  }, [showModal]);

  // Pagination and filtering
  const filtered = orders.filter((o) =>
    o.orderid.toLowerCase().includes(search.toLowerCase()),
  );
  const totalPages = Math.ceil(filtered.length / pageSize);
  const paginatedData = filtered.slice((page - 1) * pageSize, page * pageSize);

  // Open modal
  const openCancelModal = (order) => {
    console.log("Opening modal for order:", order.orderid);

    setSelectedOrder(order);
    setReason("");

    // allow UI to breathe before heavy re-render
    setTimeout(() => {
      setShowModal(true);
    }, 0);
  };
  const closeCancelModal = () => {
    setShowModal(false);
    setSelectedOrder(null);
    setReason("");
  };

  // Handle cancel order
  const handleCancelOrder = async (orderId) => {
    if (!orderId) return;

    try {
      const res = await cancelOrder({ orderid: orderId ,cancelorderdesc: reason,});

      // ✅ CORRECT USAGE
      showSnackbar(
        "success",
        res?.data?.message || "Order canceled successfully"
      );

      closeCancelModal();
      fetchOrders();
    } catch (err) {
      console.error(err?.response?.data || err.message);

      showSnackbar(
        "error",
        err?.response?.data?.message || "Failed to cancel order"
      );
    }
  };


  return (
    <div className="admin-orders">
      {/* Search */}
      <input
        type="text"
        placeholder="Search by Order ID"
        className="search-box"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setPage(1);
        }}
      />

      {/* Table */}
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Order Date</th>
              <th>Net Amount</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((item, index) => (
                <tr key={index}>
                  <td>{item.orderid}</td>
                  <td>
                    {new Date(item.orderdate).toLocaleDateString("en-GB")}
                  </td>
               <td>₹ {Number(item?.netamount || 0).toFixed(2)}</td>
                  <td>
                    <button
                      className="cancel-btn"
                      onClick={() => openCancelModal(item)}
                    >
                      Cancel Order
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={4}
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  {orders.length === 0
                    ? "Loading orders..."
                    : "No orders found."}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
     
<div className="pagination-container">


<div>

Items per page:

<select
className="page-select"
value={pageSize}
onChange={(e) => {
setPageSize(Number(e.target.value));
setPage(1);
}}
>

{[5,10,20,50].map((n)=>(
<option key={n} value={n}>
{n}
</option>
))}

</select>

</div>



<div className="page-buttons">

<button
className="page-btn"
disabled={page===1}
onClick={()=>setPage(page-1)}
>
Previous
</button>


<span className="page-count">

{page} / {totalPages || 1}

</span>


<button
className="page-btn"
disabled={page===totalPages || totalPages===0}
onClick={()=>setPage(page+1)}
>
Next
</button>

</div>


</div>

      {/* Cancel Order Modal */}

      {showModal &&
        selectedOrder &&
        createPortal(
          <div className="modal-backdrop">
            <div className="custom-modal">
              <h3>Return Order #{selectedOrder.orderid}</h3>

              <p>Please provide a reason for return:</p>

              <textarea
                placeholder="Enter reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />

              <div className="modal-buttons">
                <button
                  className="confirm-btn"
                  onClick={() => handleCancelOrder(selectedOrder.orderid)}
                >
                  Confirm
                </button>

                <button className="cancel-btn" onClick={closeCancelModal}>
                  Cancel
                </button>
              </div>
            </div>
          </div>,
          document.body,
        )}

      {/* Styles */}
      <style>{`
        .admin-orders { padding: 20px; background: #fff; }
        .search-box { width: 300px; padding: 8px 12px; margin-bottom: 15px; border: 1px solid #ccc; border-radius: 4px; }
        .table-wrapper { overflow-x: auto; }
        table { width: 100%; border-collapse: collapse; }
        th { background: #f5f5f5; padding: 12px; border: 1px solid #ddd; text-align: center; font-weight: 600; }
        td { padding: 12px; border: 1px solid #ddd; text-align: center; }
        .cancel-btn { background: #ff4d4f; color: white; border: none; padding: 6px 14px; border-radius: 5px; cursor: pointer; font-size: 13px; }
        .cancel-btn:hover { background: #d9363e; }
        .pagination { display: flex; justify-content: space-between; align-items: center; border-top: 1px solid #eee; padding-top: 15px; margin-top: 15px; }
        .items-per-page select { margin-left: 8px; padding: 4px 8px; border-radius: 4px; border: 1px solid #ccc; }
        .page-controls button { padding: 6px 12px; margin: 0 4px; border: 1px solid #ccc; border-radius: 4px; background: white; cursor: pointer; }
        .page-controls button:disabled { opacity: 0.5; cursor: not-allowed; }

        /* Modal styles */
      .modal-backdrop {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;       /* Increase z-index */
}

.custom-modal {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 4px 10px rgba(0,0,0,0.3);
  z-index: 10000;
  position: relative;
  display: block;   /* IMPORTANT */
}
        .modal textarea { width: 100%; height: 80px; padding: 8px; margin-top: 10px; border-radius: 5px; border: 1px solid #ccc; resize: none; }
        .modal-buttons { margin-top: 15px; display: flex; justify-content: flex-end; gap: 10px; }
        .confirm-btn { background: #ff4d4f; color: white; border: none; padding: 6px 14px; border-radius: 5px; cursor: pointer; }
        .confirm-btn:hover { background: #d9363e; }
      `}</style>
    </div>
  );
};

export default AdminOrdersList;
